/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
import VCalendar from 'v-calendar'; // https://vcalendar.io

require('./bootstrap');

window.Vue = Vue;

window.events = new Vue();

window.flash = function (message, level = 'success') {
    window.events.$emit('flash', { message, level });
};

Vue.component('flash', require('./components/Flash.vue').default);
Vue.component('google-auth', require('./components/Auth/GoogleLogin').default);

Vue.component('customer-import-upload-import-file', require('./components/ImportCustomer/UploadFile.vue').default);
Vue.component('customer-import-map-fields', require('./components/ImportCustomer/MapFields.vue').default);
Vue.component('customer-import-handle-invalid-rows', require('./components/ImportCustomer/HandleInvalidRows.vue').default);
Vue.component('customer-import-handle-duplicates', require('./components/ImportCustomer/HandleDuplicates.vue').default);
Vue.component('customer-import-show-summary', require('./components/ImportCustomer/Summary.vue').default);

Vue.component('product-import-upload-import-file', require('./components/ImportProduct/UploadFile.vue').default);
Vue.component('product-import-map-fields', require('./components/ImportProduct/MapFields.vue').default);
Vue.component('product-import-handle-invalid-rows', require('./components/ImportProduct/HandleInvalidRows.vue').default);
Vue.component('product-import-handle-duplicates', require('./components/ImportProduct/HandleDuplicates.vue').default);
Vue.component('product-import-show-summary', require('./components/ImportProduct/Summary.vue').default);

Vue.component('gift-card-import-upload-import-file', require('./components/ImportGitCards/UploadFile.vue').default);
Vue.component('gift-card-import-map-fields', require('./components/ImportGitCards/MapFields.vue').default);
Vue.component('gift-card-import-handle-invalid-rows', require('./components/ImportGitCards/HandleInvalidRows.vue').default);
Vue.component('gift-card-import-handle-duplicates', require('./components/ImportGitCards/HandleDuplicates.vue').default);
Vue.component('gift-card-import-show-summary', require('./components/ImportGitCards/Summary.vue').default);

Vue.component('restart-import', require('./components/Import/Restart.vue').default);

Vue.component('user-profile', require('./components/User/Profile').default);

import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue);
Vue.use(VCalendar, {});

const app = new Vue({
    el: '#app',
});
